import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Subscription } from 'rxjs';
import { DownloadService, IDownloadItems, IStandEquipmentsCounter } from '../../services/download.service';
import { SessionService } from '../../services/session.service';

import { SHARED_MODULES } from '../../../shared.';
import { PhIconWrapperComponent } from '../ph-icon-wrapper/ph-icon-wrapper.component';
import { PhIconComponent } from '../ph-icon/ph-icon.component';

@Component({
    selector: 'app-download-menu',
    templateUrl: './download-menu.component.html',
	imports: [SHARED_MODULES, PhIconComponent, PhIconWrapperComponent],
    standalone: true
})
export class DownloadMenuComponent implements OnInit, AfterViewInit, OnDestroy {

	@ViewChild('loadingsMenuTrigger') loadingsMenuTrigger: MatMenuTrigger;

	downloadList: IDownloadItems;
	private notificationSubscription: Subscription;

	constructor(
		private downloadService: DownloadService,
		private sessionService: SessionService
	) {}

	ngOnInit(): void {
		this.downloadService.onInit();
		this.downloadList = this.downloadService.downloadList;
	}

	ngAfterViewInit(): void {
		this.notificationSubscription = this.downloadService.openNotificationSubject.subscribe(() => {
			if (this.loadingsMenuTrigger?.menuOpen) {
				this.loadingsMenuTrigger.closeMenu();
			}
		});
	}

	ngOnDestroy(): void {
		if (this.notificationSubscription) {
			this.notificationSubscription.unsubscribe();
		}
	}

	calculateProgressStatus(start: number, finish: number): number {
		if (finish === 0) return 0;
		return Math.floor((start / finish) * 100);
	}

	cancelAnalyticsDownload(id: string): void {
		this.downloadService.cancelAnalyticsDownload(id);
	}

	cancelExcelFileDownload(id: string): void {
		this.downloadService.cancelExcelFileDownload(id);
	}

	downloadStandEquipments(item: IStandEquipmentsCounter): void {
		this.downloadService.downloadStandEquipments(item);
	}

	deleteStandEquipments(id: string): void {
		this.downloadService.deleteStandEquipments(id);
	}

	deleteExecution(id?: string): void {
		this.downloadService.deleteExecution(id);
	}

	deleteScheduleExecution(id?: string): void {
		this.downloadService.deleteScheduleExecution(id);
	}

	openExecutionNotification(id?: string): void {
		this.downloadService.openExecutionNotification(id);
	}

	openScheduleExecutionNotification(id?: string): void {
		this.downloadService.openScheduleExecutionNotification(id);
	}

	shouldShowReadMoreButton(isScheduleExecution: boolean = false): boolean {
		const settings = this.sessionService.personalSettings;
		const notificationsWebDisabled = settings.notificationsWebDisabled || [];
		const notificationsWebPushDisabled = settings.notificationsWebPushDisabled || [];

		const notificationType = isScheduleExecution ? 'scheduled_execution' : 'multi_execution';
		const isDisabled = notificationsWebDisabled.includes(notificationType);
		const isPushDisabled = notificationsWebPushDisabled.includes(notificationType);

		return !isDisabled && !isPushDisabled;
	}
}
